<template>
  <v-content>
    <v-container fluid>
    <v-card :elevation=1 outlined> 
      <v-card-item>
        <v-chip-group>
          <a href="https://vladlin.ru/" target="_blank"> <img :src="`/favicon.ico`" height="36"> </a>
          <v-spacer/>
          <v-text-field
            label="GF(p)"
            :hint=state.hintlang
            v-model="state.qgf" 
            :error-messages="v$.qgf.$errors.map(e => e.$message)"
            @blur="v$.qgf.$touch"
            append-inner-icon="mdi-select"
            @click:append-inner="genvalid"
            @keyup.enter="genvalid"
          ></v-text-field>
          <v-spacer/>
          <v-btn v-if="RU" @click="toEn">EN</v-btn>
          <v-btn v-if="EN" @click="toRu">RU</v-btn>
        </v-chip-group>

        <!-- <v-chip-group>
          <v-text-field
            label="Массив"
            v-model="state.gg"
            readonly
          ></v-text-field>
        </v-chip-group>-->

      </v-card-item>
    </v-card>

    <div id="scroll-container">
      <div id="large-container">
        <div id="container"></div>
      </div>
    </div>

    </v-container>
  </v-content>
</template>

<style>

  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #f0f0f0;
    background: #fcfcfc;
    height: 100%;
    overflow: auto;
  }

  #large-container {
    width: 3000px;
    height: 3000px;
    overflow: hidden;
  }

  #scroll-container {
    width: calc(100% - 22px);
    height: calc(100vh - 22px);
    overflow: auto;
    margin: 10px;
    border: 1px solid grey;
  }  

</style>

<script>
//#region import
import { 
  isArraysEqual,
  isPrime,
  found,
  reduceElArrK,
  phi,
 } from '../utils/common.js';
import { reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators'; //
import Konva from 'konva';
import { mapActions } from "vuex";//, mapGetters 
var width = window.innerWidth;
var height = window.innerHeight;
var PADDING = 500;
var layer = '';
//#endregion import

export default {
data() {
  return { 
    RU: true,
    EN: false,
    configKonva: {
      width: width,
      height: height
    },
    shifttablex: 0,
    deltashifttablex: 0,
    shifttabley: 110,
    cursor: " \u2192 ",
    err: '?', // устанавливать один символ
  };
},

setup () {
  //const numregex= helpers.regex(/^(\d*\^\d*|\d)*$/)
  const numregex= helpers.regex(/^(\d)*$/)
  
  const state = reactive({ 
    qgf: '',
    hintlang: 'простое число'
  })
  const rules = {
    qgf: { required, numregex: helpers.withMessage('p - простое число', numregex) },
  }
  const v$ = useVuelidate(rules, state)
  return { state, v$ }
},

mounted() {
//#region Konva
  var stage = new Konva.Stage({
    container: 'container',
    width: window.innerWidth + PADDING * 2,
    height: window.innerHeight + PADDING * 2,//2
    draggable: true,
  });

  layer = new Konva.Layer();
  stage.add(layer);

  var scrollContainer = document.getElementById('scroll-container');

  function repositionStage() {
    var dx = scrollContainer.scrollLeft - PADDING;
    var dy = scrollContainer.scrollTop - PADDING;
    stage.container().style.transform =
      'translate(' + dx + 'px, ' + dy + 'px)';
    stage.x(-dx);
    stage.y(-dy);
  }

  scrollContainer.addEventListener('scroll', repositionStage);
  repositionStage();
//#endregion Konva
  this.state.qgf = '7';
  //console.log('calcDeg:', this.calcDeg(11, 16));
  this.generation();
},

methods: {
  toEn() {
    this.EN = true;
    this.RU = false;
    this.state.hintlang = 'prime number';
  },
  toRu() {
    this.RU = true;
    this.EN = false;
    this.state.hintlang = 'простое число';
  },
  generation(){
    layer.removeChildren(); // обнулить канву

    let p = Number(this.state.qgf);
    let arrbase=[]; // генерация массива элементов на основе p
    for(let i=0; i<p; i++) {
      arrbase.push(i.toString());
    }

    //console.log('arrbase', arrbase);

    // Определение всех примитивов
    let arrbaseprim=[];
    let middle = (p-1)/2;

    let isPrimeMiddle = isPrime(middle);
    //console.log('isPrimeMiddle', isPrimeMiddle);

    const amountprim = phi(p-1);
    let arrprim=[];
    for(let i=2; i<(p-1); i++) {
      arrbaseprim.push(i.toString());
    }
    arrbaseprim.forEach((el) => {
      // каждый элемент возвести в середину middle
      // eslint-disable-next-line
      let resexp = this.exponentiation(el, middle) % BigInt(p);
      // если resexp равно (p-1) то элемент - примитив
      // найденные примитивы сохранить в отдельном массиве arrprim
      if (resexp == (p-1)) arrprim.push(el);
    });
    //console.log('arrprim', arrprim);

    // Найти самый широкий элемент массива и определить в нем количество знаков
    this.maxlength = arrbase[arrbase.length - 1].length;
    if (this.maxlength < 3) this.maxlength = 2.5;
    
    const deltax = this.maxlength * 15; 
    const deltay = 30, x=10; //
    let y=20;
    let prims = this.renderDegree(arrbase, p, deltax, deltay); 

    let text0RU = "'p' должен быть простым числом";
    let text0EN = "'p' must be a prime number";

    if (prims[0]==0) layer.add(this.addText(x, y, (this.RU ? text0RU : text0EN), 20, 'Arial', 'red'));
    else {
      let text1RU = 'Таблица cтепеней для GF(' + p + '), (p-1)/2  = ' +  middle + ' - ' + (isPrimeMiddle ? 'простое' : 'непростое') + ' число';
      let text1EN = 'Table of powers for GF(' + p + '), (p-1)/2  = ' +  middle + ' - ' + (isPrimeMiddle ? 'prime' : 'not a prime') + ' number';
      layer.add(this.addText(x, y, (this.RU ? text1RU : text1EN), 24)); // 24-размерШрифта
      let text2RU = 'Количество примитивов по функции Эйлера totient φ(p-1) =  ' + amountprim;
      let text2EN = 'Number of primitives by Euler totient function φ(p-1) =  ' + amountprim;
      layer.add(this.addText(x+20, y+35, (this.RU ? text2RU : text2EN), 20));
      let text3RU = (isPrimeMiddle ? 'Примитивы' : 'Кандидаты в примитивы') + ' (' + arrprim.length + ' шт.): {'  + arrprim.join('; ') + '}';
      let text3EN = (isPrimeMiddle ? 'Primitives' : 'Candidates for Primitives') + ' (' + arrprim.length + ' pcs.): {'  + arrprim.join('; ') + '}';
      layer.add(this.addText(x+20, y+70, (this.RU ? text3RU : text3EN), 20));
    } 
    //console.log('arrprim ->', arrprim.length);
  },

  renderDegree(arrbase, p, deltax, deltay) {
    let arr=[], wf=[], line=1, fill='black'; //, wp=[], ww=[] 
    let prim = 0, prim_ = 0; // первые примитивные элементы

    arr = reduceElArrK('0', arrbase, 1); 

    const n=arrbase.length;

    //console.log('arr', arr);

    //заполнить нулями
    let ar = new Array(n);
    for (let i = 0; i < ar.length; i++) {
      ar[i] = new Array(n);
      for (let j = 0; j < n; j++) {
        ar[i][j] = 0;
      }
    }
  
    //console.log('ar', ar);

    for (let y = 0; y < n; y++) {
      let neutar = [], wn=[]; //, w=[]
      for (let x = 0; x < n; x++) {
        if (y>0 && x>0) {
          const yy = arr[y-1];
          const xx = arr[x-1];
          let ardeg=[];
          ardeg = this.calcDegMode1(yy, xx, arrbase, p);
          //w.push(yy + '^'+ xx +'='+ ardeg[1]);
          wn.push(Number(ardeg[0]));
          wf.push(Number(ardeg[0]));
          ar[x][y] = ardeg[0];
          neutar.push(ardeg[0].toString());  
          //console.log('->', neutar);
        } else {
          ar[x][0] = arr[x-1];
        }
        if (y==0) {
          ar[0][x] = arr[x-1];
        }
      }
      if(neutar.length)
        if (isArraysEqual(arr.slice(0), neutar.slice(0)) && prim == 0){
          prim = ar[0][y];
          prim_ = ar[p-2][y];
          //console.log('->', ar[p-2][y]);
          //console.log('->', neutar); // поймать строку примитива  
          //ww = [...w];
          //wp = [...wn];
          //break;
        }
    }
  
    ar[0][0] = '^';

    if (prim != 0) {
      this.state.gg = wf.join(','); // 
      ar.forEach((subjects) => {
        let num = 1;
        subjects.forEach((data) => {
          this.draw(line, num, data, deltax, deltay, fill, 20);
          num++;
        });
        line++;
      });
      this.renderLine(this.shifttablex, deltax, deltay, n); // нарисовать пряиые
    }
/*     let y = (deltay*(n+1))+75; // сдвиг для расшифровки
    let shifttablex = this.shifttablex+50; */

/*     if (prim==0) layer.add(this.addText(shifttablex, y+20, "'p' должен быть простым числом", 20, 'Arial', 'red')); 
    else layer.add(this.addText(shifttablex, y, "Первый первообразный корень: " + prim, 20)); */

    // расшифровка
/*     for (let i = 0; i < ww.length; i++){
      y+=deltay;
      layer.add(this.addText(shifttablex+30, y, ww[i], 20));
    } */

    return [prim, prim_];
  },

  exponentiation(a, b) { //возведение в степень a^b
    // eslint-disable-next-line
    return BigInt(a) ** BigInt(b);
  },

  calcDegMode1(a, n, arrbase, ch){ // рассчитать a^n
    //console.log('r:', arrbase, ch);
    let w='';
    let r = this.exponentiation(a, n);
    //console.log('r:', r);
    if (!found(r.toString(), arrbase)) {
      const rr = r;
      // eslint-disable-next-line
      r = r % BigInt(ch);
      w = rr + " mod " + ch + this.cursor;
      if (!found(r.toString(), arrbase)) {
        r = this.err;
      }
    }
    //console.log('r:', r);
    return [r,w+r];
  },

  renderLine(shifttablex, deltax, deltay, n){
    const dy1 = ((deltay)-(deltay/(deltay/5))+this.shifttabley); //50
    const dy2 = ((deltay*n)-(deltay*n/(deltay*n/5))+this.shifttabley + 25); //70
    layer.add(this.addLine(deltax+shifttablex+7, dy1, deltax+shifttablex+7, dy2)); 
    const dx1 = deltax/(deltax/4)+shifttablex+5;
    const dx2 = deltax*n+shifttablex+5;
    layer.add(this.addLine(dx1, dy1+23, dx2, dy1+23)); 
  },

  addLine(x1, y1, x2, y2){
    return new Konva.Line({
      x: 0,
      y: 0,
      points: [x1, y1, x2, y2],
      stroke: 'black', //red
      //tension: 1
    });
  },

  draw(line, num, data, deltax, deltay, fill, fontSize) {
    if (data == this.err) fill = 'red';
    layer.add(this.addText(((deltax*(line-1))-(deltax/(deltax/4))+this.shifttablex+20), 
      ((deltay*num)-(deltay/(deltay/5))+this.shifttabley), data, fontSize, 'Arial', fill)); 
  },

  addText(x, y, txt, fontSize, fontFamily, fill) {
    return new Konva.Text({
      x: x,
      y: y,
      text: txt,
      fontSize: fontSize,
      fontFamily: fontFamily, //'Calibri' 'Georgia' 'Arial'
      fill: fill, // 'red' 'black'
    });
  },

  genvalid() {
    if (!this.v$.$invalid ) {
      this.generation();
    }
  },

  ...mapActions(["register"]),

}
}
</script>